var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightCircleWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8617_39078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 40C26.7739 40 31.3523 38.1036 34.7279 34.7279C38.1036 31.3523 40 26.7739 40 22C40 17.2261 38.1036 12.6477 34.7279 9.27208C31.3523 5.89642 26.7739 4 22 4C17.2261 4 12.6477 5.89642 9.27208 9.27207C5.89643 12.6477 4 17.2261 4 22C4 26.7739 5.89642 31.3523 9.27208 34.7279C12.6477 38.1036 17.2261 40 22 40V40ZM14.125 23.125C13.8266 23.125 13.5405 23.0065 13.3295 22.7955C13.1185 22.5845 13 22.2984 13 22C13 21.7016 13.1185 21.4155 13.3295 21.2045C13.5405 20.9935 13.8266 20.875 14.125 20.875L27.1593 20.875L22.3285 16.0465C22.2239 15.9419 22.1409 15.8177 22.0843 15.6811C22.0277 15.5444 21.9986 15.3979 21.9986 15.25C21.9986 15.1021 22.0277 14.9556 22.0843 14.8189C22.1409 14.6823 22.2239 14.5581 22.3285 14.4535C22.4331 14.3489 22.5573 14.2659 22.6939 14.2093C22.8306 14.1527 22.9771 14.1236 23.125 14.1236C23.2729 14.1236 23.4194 14.1527 23.5561 14.2093C23.6927 14.2659 23.8169 14.3489 23.9215 14.4535L30.6715 21.2035C30.7763 21.308 30.8594 21.4321 30.9161 21.5688C30.9728 21.7055 31.002 21.852 31.002 22C31.002 22.148 30.9728 22.2945 30.9161 22.4312C30.8594 22.5679 30.7763 22.692 30.6715 22.7965L23.9215 29.5465C23.7103 29.7577 23.4237 29.8764 23.125 29.8764C22.8263 29.8764 22.5397 29.7577 22.3285 29.5465C22.1173 29.3353 21.9986 29.0487 21.9986 28.75C21.9986 28.4513 22.1173 28.1647 22.3285 27.9535L27.1593 23.125L14.125 23.125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8617_39078",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8617_39078"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8617_39078",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightCircleWhiteIcon);
export default __webpack_public_path__ + "static/media/arrow-right-circle-white-icon.3ad28f39b2f96674c1026a5596c0a5c7.svg";
export { ForwardRef as ReactComponent };